import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
  DialogClose,
} from '@/web/components/ui/dialog';
import { PaginationEllipsisButton } from '@/web/components/atoms/PaginationEllipsisButton';
import { PaginationNavItem } from '@/web/components/atoms/PaginationNavItem';
import { Button } from '@/web/components/ui/button';
import type { PaginationPage } from '@/types';

export interface PageGridModalProps {
  pages: PaginationPage[];
  categoryId: string;
  subcategoryId?: string | null | undefined;
}

export function PageGridModal({
  pages,
  categoryId,
  subcategoryId,
}: PageGridModalProps): React.ReactElement {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <PaginationEllipsisButton />
      </DialogTrigger>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Select Page</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-8 gap-2 max-h-[60vh] overflow-y-auto p-1">
          {pages.map((p) => (
            <DialogClose key={p.label} asChild>
              <PaginationNavItem
                page={p}
                categoryId={categoryId}
                subcategoryId={subcategoryId}
              />
            </DialogClose>
          ))}
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="outline" className="w-[120px]">
              Close
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
